export enum SharePointTypes {
  SHAREPOINT_SETTINGS_REQUEST = 'userData/SharePoint/SHAREPOINT_SETTINGS_REQUEST',
  SHAREPOINT_SETTINGS_SUCCESS = 'userData/SharePoint/SHAREPOINT_SETTINGS_SUCCESS',
  SHAREPOINT_SETTINGS_FAILURE = 'userData/SharePoint/SHAREPOINT_SETTINGS_FAILURE',

  SHAREPOINT_SITES_REQUEST = 'userData/SharePoint/SHAREPOINT_SITES_REQUEST',
  SHAREPOINT_SITES_SUCCESS = 'userData/SharePoint/SHAREPOINT_SITES_SUCCESS',
  SHAREPOINT_SITES_FAILURE = 'userData/SharePoint/SHAREPOINT_SITES_FAILURE',

  SHAREPOINT_DRIVES_REQUEST = 'userData/SharePoint/SHAREPOINT_DRIVES_REQUEST',
  SHAREPOINT_DRIVES_SUCCESS = 'userData/SharePoint/SHAREPOINT_DRIVES_SUCCESS',
  SHAREPOINT_DRIVES_FAILURE = 'userData/SharePoint/SHAREPOINT_DRIVES_FAILURE',

  SHAREPOINT_SAVE_REQUEST = 'userData/SharePoint/SHAREPOINT_SAVE_REQUEST',
  SHAREPOINT_SAVE_SUCCESS = 'userData/SharePoint/SHAREPOINT_SAVE_SUCCESS',
  SHAREPOINT_SAVE_FAILURE = 'userData/SharePoint/SHAREPOINT_SAVE_FAILURE',

  SHAREPOINT_SET_SELECTED_SITE = 'userData/SharePoint/SHAREPOINT_SET_SELECTED_SITE',
  SHAREPOINT_SET_SELECTED_DRIVE = 'userData/SharePoint/SHAREPOINT_SET_SELECTED_DRIVE',
  SHAREPOINT_SET_FOLDER_PATH = 'userData/SharePoint/SHAREPOINT_SET_FOLDER_PATH',

  SHAREPOINT_RESET = 'userData/SharePoint/SHAREPOINT_RESET',
}
